var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.311,
    height: 82.593,
    viewBox: "0 0 91.311 82.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_5853419",
    transform: "translate(0 -24.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39864",
    "data-name": "Path 39864",
    d: "M0,225.227v46.785H91.311V225.227ZM62.5,234.7H74.19v5.35H62.5Zm0,10.709H74.19v5.35H62.5Zm0,10.709H74.19v5.35H62.5ZM39.811,234.7H51.5v5.35H39.811Zm0,10.709H51.5v5.35H39.811Zm0,10.709H51.5v5.35H39.811ZM17.121,234.7H28.81v5.35H17.121Zm0,10.709H28.81v5.35H17.121Zm0,10.709H28.81v5.35H17.121Z",
    transform: "translate(0 -164.978)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39865",
    "data-name": "Path 39865",
    d: "M91.311,103.965V95.748A11.605,11.605,0,0,0,79.719,84.156H75.736V97.879H53.621V84.156H37.69V97.879H15.575V84.156H11.592A11.605,11.605,0,0,0,0,95.748v8.216H91.311Z",
    transform: "translate(0 -49.066)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39866",
    "data-name": "Path 39866",
    d: "M117.334,43.463h11.414V30.147a5.707,5.707,0,0,0-11.414,0Z",
    transform: "translate(-96.409)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39867",
    "data-name": "Path 39867",
    d: "M330.667,43.463h11.414V30.147a5.707,5.707,0,1,0-11.414,0Z",
    transform: "translate(-271.695)",
    fill: "#fc7336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavEventIcon);
export default __webpack_public_path__ + "static/media/favEvent_icon.a5b695ac3be5a9a453ee1cd0ff472ec7.svg";
export { ForwardRef as ReactComponent };